import { getFromLocalStorageWithExpiry, setLocalStorageWithExpiry } from './localstorage';

type CacheContext = {
  userId?: string;
  language?: string;
};

const HOME_CACHE_ENABLED = process.env.REACT_APP_HOME_CACHE_ENABLED !== 'false';
const DEFAULT_TTL_MS = 1000 * 60 * 60 * 6; // 6 hours

const buildKey = (key: string, context: CacheContext): string => {
  const user = context.userId ?? 'anon';
  const language = context.language ?? 'default';
  return `home-cache:${key}:user=${user}:lang=${language}`;
};

export const readHomeCache = <T>(key: string, context: CacheContext): T | null => {
  if (!HOME_CACHE_ENABLED) return null;
  return getFromLocalStorageWithExpiry(buildKey(key, context)) as T | null;
};

export const writeHomeCache = <T>(
  key: string,
  context: CacheContext,
  value: T,
  ttlMs: number = DEFAULT_TTL_MS
): void => {
  if (!HOME_CACHE_ENABLED) return;
  if (value == null) return;
  if (Array.isArray(value) && value.length === 0) return;
  setLocalStorageWithExpiry(buildKey(key, context), value, ttlMs);
};

export const HOME_CACHE_TTL_MS = DEFAULT_TTL_MS;
